import { Component, OnInit, Inject } from '@angular/core';
// import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { environment } from '../../../environments/environment';
import { SettingService } from "../../_services/setting.service";
import { Auth0Service } from '../../_services/auth0.service';

// export interface DialogData {
//   is_public_url: string,
//   turnAroundTimes: Array<any>,
//   turn_around_time: string,
//   turnAroundName: string,
//   shipping_method: string,
//   shipping: Array<any>,
//   orderType: string,
//   quote_id: string,
//   user_id: string,
//   SelectProductData: any,
//   priceData: any,
//   postData: any
// }

declare var grecaptcha: any;
@Component({
  selector: 'app-store-check-out',
  templateUrl: './store-check-out.component.html',
  styleUrls: ['./store-check-out.component.css']
})
export class StoreCheckOutComponent implements OnInit {
  public id: string;
  public isShowCheckout = false;
  public isShowNextButton = true;
  public order_id:string;
  public totalQty=0;
  public subTotal=0;
  private myStepper:MatStepper;
  storeCheckOutForm: FormGroup;
  selectedType = 0;
  address_id = "";
  loading: any = false;
  cardData: any = {};
  cardTypes: Array<any> = [
    { value: "0", viewValue: "Use New Card" },
    { value: "1", viewValue: "Old Card" }
  ];
  expiryMonths: Array<any> = [
    { value: "", viewValue: "Month" },
    { value: "1", viewValue: "1" },
    { value: "2", viewValue: "2" },
    { value: "3", viewValue: "3" },
    { value: "4", viewValue: "4" },
    { value: "5", viewValue: "5" },
    { value: "6", viewValue: "6" },
    { value: "7", viewValue: "7" },
    { value: "8", viewValue: "8" },
    { value: "9", viewValue: "9" },
    { value: "10", viewValue: "10" },
    { value: "11", viewValue: "11" },
    { value: "12", viewValue: "12" }
  ];

  expiryYears: Array<any> = [
    { value: "", viewValue: "Year" },
  ];
  public partialPaymentType = 'full';
  public shippingMethodName: string;
  public data:any={};
  public storeData: any = {};
  myScriptElement: HTMLScriptElement | undefined;
  payments: any;
  appId: any;
  locationId: any;
  card: any;
  shouldLoadScript = false;
  recaptchaResult: string = '';
  captchaWidgetId = null;

  constructor(private formBuilder: FormBuilder,   
    private CommonService: CommonService,
    private SettingService: SettingService,
    private _flashMessagesService: FlashMessagesService,
    private CommonProjectDataService: CommonProjectDataService,
    private auth0Service: Auth0Service,
    private router: Router
    ) {

    this.storeCheckOutForm = this.formBuilder.group({
      card_type: [0],
      card_no: [null],
      expiry_month: [null],
      expiry_year: [null],
      cvv: [null],
      amount: [null, Validators.required],
      newaccount: [null],
      payment_mode: ['Cash', Validators.required],
      //address: [null, Validators.required],
      po_number: [null],
      cheque_number: [null],
      pay_later_code: [null]
    });
    // this.CommonProjectDataService.receivableCount.subscribe(recCount => {
    //   this.receivableCount = recCount
    // })
  }
  

  ngOnInit() {
    //this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.storeData = JSON.parse(localStorage.getItem("storeData"));
    this.data=this.CommonProjectDataService.getStoreCheckOut(); 
    this.shippingMethodName = this.storeData.is_local_pickup == 'Yes' ? 'Local Pickup' : '';
    // this.data.shipping= this.data.shipping.filter(x=>x.key_value=='local_pickup' || x.key_value=='ParcelSelect__USPS' || x.key_value=='Priority__USPS');
   
    if (this.data.is_public_url == 'Yes') {
      this.id = this.data.SelectProductData[0].product[0].shop_id;
      if (this.data.priceData.cc_payment_enable) {
        this.storeCheckOutForm.get("payment_mode").setValue('Card');
      }
      else {
        if (this.data.priceData.paypal_payment_enable) {
          this.storeCheckOutForm.get("payment_mode").setValue('PayPal');
        }
      }

    }
    else {
      this.id = this.data.SelectProductData[0].product[0].shop_id;
    }



    //this.selectedType=1;
    // this.turnAroundTime=this.data.turnAroundTime?this.data.turnAroundTime:'';   
    // if (this.data.projects.type == 'Invoice') {
    //   this.shippingAddressId = this.data.projects.shipping_address.address_id ? this.data.projects.shipping_address.address_id : '';
    //   this.balanceAmount = this.data.projects.grand_total_price - this.data.paidAmount;
    // }
    // else {
    //   this.shippingAddressId = this.data.projects.address_id ? this.data.projects.address_id : '';
    // }


    //this.tempProjectData = JSON.parse(JSON.stringify(this.data.projects.projects_data));
    // this.shippingMethodName = this.data.projects.shipping_method;
    //this.deliveryDate = this.CommonProjectDataService.getDeliveryDate();
    // if (this.data.order_instructions_payment == null || this.data.order_instructions_payment == '') {
    //   this.popHeading = "Checkout";
    //   this.showInstruction = false;
    // }
    // else {
    //   this.popHeading = this.data.order_instruction_title;
    //   this.showInstruction = true;
    // }
    this.getExpiryYears();
    //this.getCards();
    if (this.data.quote_id != "") {
      this.storeCheckOutForm.get("amount").setValue(this.numRoundToPlace(this.data.priceData.grand_total_price, 2));
    }
    this.paymentTypeChanged();
  }

  selectTrunAround(selectedTurnAround) {
    if (selectedTurnAround != "") {
      this.data.turn_around_time = selectedTurnAround;
      this.data.turnAroundName = this.data.turnAroundTimes[this.data.turn_around_time];
      //this.data.turn_around_time_key = selectedTurnAround;
      //call get price api            
      this.getPrice();
    }
    else {
      this._flashMessagesService.show("Please Select Turn Around", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      this.data.turn_around_time = "";
      //this.data.projects.turn_around_time_key = "";
    }
    //this.validateShippingDetail();
  }

  selectShippingMethod(selectedShippingMethod) {
    if (selectedShippingMethod != "") {
      this.data.shipping_method = selectedShippingMethod;
      this.shippingMethodName = this.data.shipping.find(x => x.key_value === selectedShippingMethod).name.split('(').shift();
      // this.data.projects.shipping_method_key = this.data.shipping_method;
      //call get price api            
      this.getPrice();
    }
    else {
      this._flashMessagesService.show("Please Select Shipping Method", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      this.data.shipping_method = "";
      //this.data.projects.shipping_method_key = this.data.shipping_method;
    }
    //this.validateShippingDetail();

  }


  selectCardType(selectedCardValue) {
    this.selectedType = selectedCardValue;
  }

  selectAddress(selectedAddress) {
    this.address_id = selectedAddress;

  }
  // onNoClick(): void {
  //   this.dialogRef.close();
  // }
  getExpiryYears() {
    var date = new Date();
    for (let currentYear = 0; currentYear < 10; currentYear++) {
      this.expiryYears.push(
        {
          value: date.getFullYear() + currentYear,
          viewValue: date.getFullYear() + currentYear
        });

    }
  }
  convertToNumber(value) {
    return Number(value);
  }

  numRoundToPlace(num, dec) {

    if ((typeof num !== 'number') || (typeof dec !== 'number'))
      return num;

    var num_sign = num >= 0 ? 1 : -1;

    return (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec);
  }

  getCards = function () {
    this.loading = true;
    let cardOptions = {
      id: this.id,
      user_id: this.data.user_id //'865afcdbe81bb883abaa2b20c3ae0050' 
    }
    this.CommonService.apiService(
      "POST",
      "get/card",
      cardOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.cardData = response.data;
            this.address_id = this.cardData.addresses.find(x => x.is_billing == 1).address_id;
            // this.storeCheckOutForm.get('address').setValue(this.address_id);
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
  //conditional validation function for  change card type
  paymentTypeChanged() {
    const cardTypeControl = this.storeCheckOutForm.get('card_type');
    const cardNoControl = this.storeCheckOutForm.get('card_no');
    const expiryMonthControl = this.storeCheckOutForm.get('expiry_month');
    const expiryYearControl = this.storeCheckOutForm.get('expiry_year');
    const cvvControl = this.storeCheckOutForm.get('cvv');
    const checkoutCodeControl = this.storeCheckOutForm.get('pay_later_code');
    const newAccountControl = this.storeCheckOutForm.get('newaccount');
    this.storeCheckOutForm.get('card_type').valueChanges.subscribe(
      (mode: string) => {
        if (mode != '0') {
          cardNoControl.clearValidators();
          expiryMonthControl.clearValidators();
          expiryYearControl.clearValidators();
          cvvControl.clearValidators();
        }
        else {
          cardNoControl.setValidators([Validators.required]);
          expiryMonthControl.setValidators([Validators.required]);
          expiryYearControl.setValidators([Validators.required]);
          cvvControl.setValidators([Validators.required]);
        }

        cardNoControl.updateValueAndValidity();
        expiryMonthControl.updateValueAndValidity();
        expiryYearControl.updateValueAndValidity();
        cvvControl.updateValueAndValidity();

      });
    this.storeCheckOutForm.get('payment_mode').valueChanges.subscribe(
      (mode: string) => {
        if (mode == 'PaymentTerm') {
          this.storeCheckOutForm.get("amount").setValue(0);
        }
        else {
          this.storeCheckOutForm.get("amount").setValue(this.data.priceData.grand_total_price);
        }
        if (mode == 'Cash' || mode == 'Cheque' || mode == 'PayPal' || mode == 'PaymentTerm') {
          cardNoControl.clearValidators();
          expiryMonthControl.clearValidators();
          expiryYearControl.clearValidators();
          cvvControl.clearValidators();
          checkoutCodeControl.clearValidators();
        }
        else {
          if (mode == 'PayLater') {
            checkoutCodeControl.setValidators([Validators.required]);
            cardNoControl.clearValidators();
            expiryMonthControl.clearValidators();
            expiryYearControl.clearValidators();
            cvvControl.clearValidators();
          } else {
            checkoutCodeControl.clearValidators();
            if (cardTypeControl.value != 0) {
              cardNoControl.clearValidators();
              expiryMonthControl.clearValidators();
              expiryYearControl.clearValidators();
              cvvControl.clearValidators();
            }
            else {
              cardNoControl.setValidators([Validators.required]);
              expiryMonthControl.setValidators([Validators.required]);
              expiryYearControl.setValidators([Validators.required]);
              cvvControl.setValidators([Validators.required]);
            }
          }
        }

        cardNoControl.updateValueAndValidity();
        expiryMonthControl.updateValueAndValidity();
        expiryYearControl.updateValueAndValidity();
        cvvControl.updateValueAndValidity();
        checkoutCodeControl.updateValueAndValidity();

        this.recaptchaResult = '';
        if (this.data.priceData.cc_payment_api == 'quickbooks' && mode == 'Card') {
          this.renderReCaptcha();
        }
      });
  }

  isFieldValid(field: string) {
    return (
      !this.storeCheckOutForm.get(field).valid &&
      this.storeCheckOutForm.get(field).touched
    );
  }

  getPrice = function () {
    this.loading = true;
    let optionData = {
      shop_id: this.data.SelectProductData[0].product[0].shop_id, //localStorage.getItem("userID"),
      order_data: this.data.SelectProductData,
      store_id: this.data.SelectProductData[0].product[0].store_id,
      address: {
        billing_address: {
          first_name: this.data.postData.firstName,
          last_name: this.data.postData.lastName,
          zip: this.data.postData.zip,
          city: this.data.postData.city,
          county: this.data.postData.country,
          state: this.data.postData.state,
          address1: this.data.postData.address
        },
        shipping_address: {
          first_name: this.data.postData.firstName,
          last_name: this.data.postData.lastName,
          zip: this.data.postData.zip,
          city: this.data.postData.city,
          county: this.data.postData.country,
          state: this.data.postData.state,
          address1: this.data.postData.address
        }
      },
      shipping_method: this.data.shipping_method,
      shipping_zip: this.data.postData.zip,
      turn_around_time: this.data.turn_around_time
    }


    this.CommonService.apiService(
      "POST",
      "store/get_prices",
      optionData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          this.data.priceData = response.data;
          this.storeCheckOutForm.get("amount").setValue(this.numRoundToPlace(this.data.priceData.grand_total_price, 2));

          // this.shipping = [];
          Object.entries(response.data.shipping_methods).forEach(
            ([skey, value]) => {
              this.data.shipping.push(
                {
                  key_value: skey,
                  name: value
                });
            });
          if(this.data.priceData.cc_payment_enable && this.shouldLoadScript) {
            this.shouldLoadScript = false;
            this.loadUnloadScript(this.data.priceData.cc_payment_api, 'Card');
          }
        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );


  }

  saveData = function () {

    if (this.shippingMethodName) {
      this.loading = true;
      let optionData = {
        shop_id: this.data.SelectProductData[0].product[0].shop_id, //localStorage.getItem("userID"),
        order_data: this.data.SelectProductData,
        store_id: this.data.SelectProductData[0].product[0].store_id,
        quote_id: this.data.SelectProductData[0].product[0].order_id,
        address: {
          billing_address: {
            first_name: this.data.postData.firstName,
            last_name: this.data.postData.lastName,
            zip: this.data.postData.zip,
            city: this.data.postData.city,
            county: this.data.postData.country,
            state: this.data.postData.state,
            address1: this.data.postData.address
          },
          shipping_address: {
            first_name: this.data.postData.firstName,
            last_name: this.data.postData.lastName,
            zip: this.data.postData.zip,
            city: this.data.postData.city,
            county: this.data.postData.country,
            state: this.data.postData.state,
            address1: this.data.postData.address
          }
        },
        shipping_method: this.data.shipping_method,
        shipping_zip: this.data.postData.zip,
        turn_around_time: this.data.turn_around_time,
        personal_info: { "email": this.data.postData.email },
        total_quantity: this.data.priceData.total_quantity,
        shipping_price: this.data.priceData.shipping_price,
        total_price: this.data.priceData.total_price,
        tax: this.data.priceData.tax,
        tax_percentage: this.data.priceData.tax_percentage,
        grand_total_price: this.data.priceData.grand_total_price,
        turn_around_time_price: this.data.priceData.turn_around_time_price,
        delivery_days: this.data.priceData.delivery_days,
        total_weight: this.data.priceData.total_weight
      }


      this.CommonService.apiService(
        "POST",
        "store/add_order",
        optionData
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.loading = false;
            this.isShowCheckout = true;
            this.order_id=response.data.order_id;
            this.shouldLoadScript = true;
            this.getPrice();
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
          }
        },
        err => {
          this.loading = false;
          console.log("error msg", err.error.message);
        }
      );
    } else {
      this._flashMessagesService.show("Please select Delivery Preference", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  togglePayment(status) {

    if (status == true) {
      //this.dialogRef.close("success");
      this._flashMessagesService.show("Your payment has been successful", {
        cssClass: "alert-success",
        timeout: 5000
      });
      this.router.navigate(["store/thank-you/",{ order_id: this.order_id }]);
    }
  }

  processPayments = function (postData) {
    const paymentData = new FormData();
    if (postData.amount > this.data.amount) {
      this._flashMessagesService.show("Amount is invalid", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      return

    }

    paymentData.append('id', this.data.SelectProductData[0].product[0].shop_id);
    paymentData.append('order_id', this.order_id);
    paymentData.append('store_id', this.data.SelectProductData[0].product[0].store_id);
    paymentData.append('quote_id', this.data.SelectProductData[0].product[0].order_id);    
    paymentData.append('payment_type', postData.payment_mode);
    paymentData.append('amount', postData.amount);    
    if (postData.payment_mode == "Card") {
      //paymentData.append('card_id', postData.card_type);
      if (postData.card_type == "0") {
        paymentData.append('card_number', postData.card_no);
        paymentData.append('card_expiry_month', postData.expiry_month);
        paymentData.append('card_expiry_year', postData.expiry_year);
        paymentData.append('card_cvv', postData.cvv);
        //paymentData.append('is_card_save', postData.newaccount == true ? '1' : '0');

        if (this.data.priceData.cc_payment_api == 'quickbooks') {
          paymentData.append('recaptcha', this.recaptchaResult);
        }
      }
    }
    else {
      paymentData.append('pay_later_code', postData.pay_later_code);
    }
    this.loading = true;
    this.CommonService.apiService(
      "POST",
      "store/payment",
      paymentData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          // if (postData.payment_mode == "PaymentTerm") {
          //   this.CommonProjectDataService.receivableCount.next(this.receivableCount + 1);
          //   this.userDetails.receivable_count = this.receivableCount;
          //   localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
          // }
          //this.dialogRef.close("success");
          // this._flashMessagesService.show("Your payment has been successful", {
          //   cssClass: "alert-success",
          //   timeout: 5000
          // });//2000000132 
          if (response.data && response.data.customer_invoiceId) {
            localStorage.setItem("customerInvoiceId", response.data.customer_invoiceId);
          }
          if (response.data && response.data.mode) {
            localStorage.setItem("customerInvoiceMode", response.data.mode);
          }
          this.router.navigate(["store/thank-you/",{ order_id: this.order_id }]);
        } else {
          this.loading = false;
        }
        window.scrollTo(0, 0);

      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });

        if (err.error.recaptcha) {
          this.resetReCaptcha();
        }
      }
    );
  };
  callAction(value) {   
    if (value == 'payment') {
      this.saveData();
     }
  }
  setStepper(stepper: MatStepper){
    this.myStepper=stepper;
    console.log('stepper',stepper._focusIndex);
  }

   //# SquareUp Payment Gateway

  squareUpPaymentClick = async function () {
    this.data.store_order_id = this.order_id;
    var payableAmount = Number(this.storeCheckOutForm.value.amount);
    if (payableAmount > this.data.amount) {
      this._flashMessagesService.show("Amount is invalid", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      return
    }
    localStorage.setItem("storePaymentBySquare", "processing");
    localStorage.setItem("storeProcessingOrder", this.data.store_order_id);
    localStorage.setItem("storeProcessingData", JSON.stringify(this.data));
    localStorage.setItem("storeSquarePayableAmount", String(payableAmount));
    await this.handlePaymentMethodSubmission(payableAmount);
  }

  changePaymentMethod(event) {
    this.loadUnloadScript(this.data.priceData.cc_payment_api, event.value);
  }

  loadUnloadScript(cc_payment_api, payment_mode) {
    if(cc_payment_api == 'squareup' && payment_mode == 'Card') {
      this.getApiInfoSettings();
    }
    else{
      this.unloadScript();
    }

    this.recaptchaResult = '';
    if (cc_payment_api == 'quickbooks' && payment_mode == 'Card') {
      this.renderReCaptcha();
    }
  }

  getApiInfoSettings = function () {
    this.loading = true;
    this.auth0Service.getOAuth2SquareupKeys(this.id).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          let squareupData = response.data;
          this.locationId = squareupData.location_id;
          this.appId = squareupData.app_id;
          this.loadScript();
        } else {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
        console.log(err.error);
      }
    );
  };

  loadScript() {
    this.loadSquareScript().then(() => {
      this.initializeSquare();
    });
  }

  unloadScript() {
    if (this.myScriptElement) {
      const elements: NodeListOf<Element> = document.querySelectorAll('.sq-card-wrapper');
      const elementArray: Element[] = Array.from(elements);
      elementArray.forEach(element => element.remove());
    }
  }

  loadSquareScript(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.myScriptElement = document.createElement('script');
      this.myScriptElement.src = environment.SQUAREUP_URL;
      this.myScriptElement.onload = () => resolve(); // Resolve the Promise when the script is loaded successfully
      this.myScriptElement.onerror = reject; // Reject the Promise if the script fails to load
      document.body.appendChild(this.myScriptElement);
    });
  }

  async initializeSquare(): Promise<void> {
    if (!window.Square) {
      throw new Error('Square.js failed to load properly');
    }
    try {
      this.payments = window.Square.payments(this.appId, this.locationId);
      this.card = await this.initializeCard(this.payments);
    } catch (ex) {
      this._flashMessagesService.show(ex, {
        cssClass: "alert-danger",
        timeout: 5000
      });
      return;
    }
  }

  async handlePaymentMethodSubmission(amount): Promise<void> {
    try {
      if (!this.loading) {
        this.loading = true;
      }
      const token = await this.tokenize(this.card);
      this.createPayment(token, amount);
    } catch (e) {
      this.loading = false
      console.error(e.message);
      this._flashMessagesService.show(e.message, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  async tokenize(paymentMethod: any) {
    const tokenResult = await paymentMethod.tokenize();
    if (tokenResult.status === 'OK') {
      return tokenResult.token;
    } else {
      let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
      if (tokenResult.errors) {
        errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`;
      }
      this._flashMessagesService.show(errorMessage, {
        cssClass: "alert-danger",
        timeout: 5000
      });
      throw new Error(errorMessage);
    }
  }
  
  async initializeCard(payments: any) {
    const card = await payments.card();
    await card.attach('#card-container');
    return card;
  }

  createPayment(token: any, amount) {
    this.loading = true;
    const payload = {
      order_id: this.data.order_id,
      store_order_id: this.order_id,
      paymentData: {
        idempotencyKey: this.generateUUID(),
        sourceId: token,
        amount: amount
      }
    };
    this.CommonService.SquareUpPayment(payload).subscribe((response: any) => {
      if (response.status === true) {
        this._flashMessagesService.show(response.message, {
          cssClass: "alert-success",
          timeout: 5000
        });
        if (localStorage.getItem("storeProcessingData") && localStorage.getItem("storeProcessingOrder") && localStorage.getItem("storePaymentBySquare") == "processing") {
          const storeProcessingData = JSON.parse(localStorage.getItem("storeProcessingData"));
          const storeOrderId = localStorage.getItem("storeProcessingOrder");
          const storeTransactionId = response.data.payment.id;
          const storeSquareAmount =  +localStorage.getItem("storeSquarePayableAmount");
          this.squareupProcessPayments(storeProcessingData, storeOrderId, storeTransactionId, storeSquareAmount);
        } else {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
      err => {
        this.loading = false;
        console.log("Error:- ", err);
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);
      }
    );
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  squareupProcessPayments = function (data, orderId, transactionId, squareAmount) {
    const paymentData = new FormData();
    paymentData.append('id', data.SelectProductData[0].product[0].shop_id);
    paymentData.append('order_id', orderId);
    paymentData.append('store_id', data.SelectProductData[0].product[0].store_id);
    paymentData.append('quote_id', data.SelectProductData[0].product[0].order_id);
    paymentData.append('payment_type', 'Squareup');
    paymentData.append('transaction_id', transactionId);
    paymentData.append('amount', squareAmount);

    this.loading = true;
    this.CommonService.apiService(
      "POST",
      "store/payment",
      paymentData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });
          if (response.data && response.data.customer_invoiceId) {
            localStorage.setItem("customerInvoiceId", response.data.customer_invoiceId);
          }
          if (response.data && response.data.mode) {
            localStorage.setItem("customerInvoiceMode", response.data.mode);
          }
          this.router.navigate(["store/thank-you/",{ order_id: this.order_id }]);
        } else {
          this.loading = false;
          this._flashMessagesService.show("Payment did't process, please contact administration", {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  renderReCaptcha() {
    grecaptcha.ready(() => {
      this.captchaWidgetId = grecaptcha.render('recaptcha-container', {
        'sitekey': environment.recaptcha.siteKey,
        'callback': this.onCaptchaResolved.bind(this),
        'expired-callback': this.onCaptchaExpired.bind(this) 
      });
    });
  }

  onCaptchaResolved(response: string) {
    this.recaptchaResult = response;
  }

  onCaptchaExpired() {
    this.recaptchaResult = '';
  }

  resetReCaptcha() {
    this.recaptchaResult = '';
    if (this.captchaWidgetId !== null) {
      grecaptcha.reset(this.captchaWidgetId);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-check-out/store-check-out.component.ts